import { Link } from "react-router-dom";

/**
 * A single nav row item rendered as either a router <Link/> or a smooth-scroll
 * anchor depending on `item.type`.
 *
 * Keeping this in its own file lets <Header/> stay small and lets the desktop
 * + mobile nav lists share a single rendering primitive.
 */
export default function NavLinkItem({ item, onAnchorClick, variant = "desktop" }) {
  const slug = item.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const testId = variant === "mobile" ? `mobile-nav-${slug}` : `nav-${slug}`;

  const className =
    variant === "mobile"
      ? "font-display text-base py-3 px-2 border-b border-border/40 text-foreground/85 hover:text-primary transition-colors"
      : "font-display text-[0.95rem] tracking-tight text-foreground/75 hover:text-primary transition-colors duration-200 whitespace-nowrap";

  if (item.type === "anchor") {
    return (
      <a
        href={item.to}
        onClick={(e) => onAnchorClick(e, item.anchor)}
        data-testid={testId}
        className={className}
      >
        {item.label}
      </a>
    );
  }
  return (
    <Link to={item.to} data-testid={testId} className={className}>
      {item.label}
    </Link>
  );
}
